import axios from 'axios'

export default class {
    async get (busca) {
        const response = await axios.get(`api/cidades?term=${busca}`)

        return response.data
    }
}
